export default __webpack_public_path__ + "static/media/bande-detancheite.b1e5b58d.jpg";